// extracted by mini-css-extract-plugin
export default {"textWithIcon":"text-with-icon_textWithIcon__hPBz7"};